import React, { useEffect, useState, useMemo, useCallback } from "react";
import { Bar } from "@ant-design/plots";
import styled from "@emotion/styled";
import { Spin, Select, Form, } from "antd";

// Redux
import {
  getUserRoleId,
  getSelectedDepartmentId,
  getClientid,
  getLeaveCategoryList,
  getAllDepartmentList,
  getUserList,
  getIsCheckedIn,
  getUserInfo,
  getCountryList,
} from "redux/selectors";
import DepartmentAttendanceReport from "./DepartmentAttendanceReport";
import AttendanceStaffList from "./AttendanceStaffList";
import { CALL_API } from "common/API";
import { concat, isNaN, map, max, size, includes, some } from "lodash";
import { uniqBy } from "lodash";
import { connect, useSelector } from "react-redux";
import { STATUS_CODE } from "common/Constants";


const StyledChartContainer = styled.div`
  padding: 20px !important;
  box-shadow: rgba(0, 0, 0, 0.15) 0px 5px 15px;
  border-radius: 8px !important;
  height: 100%;
  .name-title {
    padding: 3px 10px;
    font-size: 1rem;
    padding-bottom: 15px;
    font-weight: 600;
  }
`;

function AttendanceBarChart({
  userRoleId,
  selectedDepartmentId,
  ClientId,
  leaveCategoryList,
  allDepartmentList,
  userList,
  isCheckedIn,
  isHrDashboard = false,
  myTeam = false,
  getSubordinates,
  userInfo,
  managingoffice,
  isMyTeam
}) {
  const [
    displayDepartmentAttendanceReportModal,
    toggleDepartmentAttendanceReportModal,
  ] = useState(false);
  const countryList = useSelector(getCountryList);
  const [displayAttendanceStaffModal, toggleDisplayAttendanceStaffModal] = useState(false);
  const [reportType, setReportType] = useState("");
  const [reportName, setReportName] = useState("");
  const [reportList, setReportList] = useState([]);
  const [reportColor, setReportColor] = useState("");
  const [attendanceReportTitle, setAttendanceReportTitle] = useState("");
  const [displayReportLoader, toggleReportLoader] = useState(false);
  const [absentList, setAbsentList] = useState([]);
  const [lateListData, setLateListData] = useState([]);
  const [onTimeList, setOnTimeList] = useState([]);
  const [leaveList, setLeaveList] = useState([]);
  const [form] = Form.useForm();



  const [reportData, setReportData] = useState([
    {
      name: "onTime",
      type: "Present",
      numbers: 0,
      list: [],
    },
    {
      name: "Absent",
      type: "Absent",
      numbers: 0,
      list: [],
    },

    {
      name: "Late",
      type: "Present",
      numbers: 0,
      list: [],
    },
    {
      name: "Leave",
      type: "leave",
      numbers: 0,
      list: [],
    },

  ]);
  // FIX: memoized so this object only gets a new reference when `reportData`
  // actually changes. Previously this was rebuilt fresh on every render
  // (including renders triggered by unrelated redux/prop updates), and
  // @ant-design/plots treats any new config reference as new chart data —
  // it would tear down and replay the bar entrance animation each time,
  // which looked like the chart was "reloading" on its own.
  const config = useMemo(
    () => ({
      isStack: true,
      data: reportData,
      dodgePadding: 0.2,
      intervalPadding: 10,
      height: 400,
      xField: "numbers",
      yField: "type",
      seriesField: "name",
      legend: false,
      // FIX: belt-and-braces — explicitly disable animation so the bars
      // can never "grow in" again on a re-render, even if something else
      // upstream still causes the config object to be replaced.
      animation: false,
      color: ({ name }) => {
        if (name === "Absent") {
          return "orange";
        } else if (name === "onTime") {
          return "#0565f5";
        } else if (name === "Late") {
          return "#5d9af5";
        } else if (name === "Leave") {
          return "#bd34eb";
        } else {
          return "#f5e0ff";
        }
      },
      theme: {
        maxColumnWidth: 50,
        minColumnWidth: 50,
      },

      label: {
        position: "middle",
        content: "",
      },
      columnStyle: {
        cursor: "pointer",
      },
      xAxis: {
        max: isNaN(max(map(reportData, "numbers")))
          ? 100
          : max(map(reportData, "numbers")) + 15,
        grid: {
          line: {
            style: {
              opacity: 0,
            },
          },
        },
      },
    }),
    [reportData]
  );

  // FIX: memoized so the <Bar> component doesn't see a "new" onReady
  // function (and re-attach a fresh plot:click listener) on every render.
  const handlePlotReady = useCallback(
    (plot) => {
      plot.on("plot:click", (evt) => {
        if (evt.data && evt.data.data !== null) {
          const {
            data: {
              data: { type, list, name },
              color,
            },
          } = evt;
          setReportList(list);
          setReportType(type);
          setReportName(name);
          if (userRoleId !== "1") {
            setAttendanceReportTitle(`${type} staff`);
            toggleDisplayAttendanceStaffModal(true);
          }
        }
      });
    },
    [userRoleId]
  );

  const annualLeaveCategoryId = leaveCategoryList.find(
    (item) => item.leave_category_short_name === "annualleave"
  );
  const sickLeaveCategoryId = leaveCategoryList.find(
    (item) => item.leave_category_short_name === "sickleave"
  );

  // FIX: default to [] so this can never be undefined downstream
  const filteruser = userList?.filter(
    (item) => item?.userid === userInfo.userid
  ) ?? [];

  // FIX: safe optional chaining on index access
  const [selectedManagingOffice, setSelectedManagingOffice] = useState(
    filteruser?.[0]?.managingoffice
  );

  useEffect(() => {
    if (
      (userRoleId !== 1 && selectedDepartmentId !== 0) ||
      userRoleId === 1 ||
      userRoleId === 6
    ) {
      getReportData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // FIX: removed the redundant/incorrect effect that depended on the raw
  // `managingoffice` prop (it wasn't the dropdown value, and it duplicated
  // the effect below — this was firing extra, unnecessary fetches).

  const getReportData = async () => {
    toggleReportLoader(true);
    try {
      if (ClientId) {
        const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
        await delay(100);

        // Generate the team tree
        let subOrdinatesList = [""];

        if (myTeam) {
          const subOrdinates = [...new Set(getSubordinates(myTeam))];
          subOrdinatesList = subOrdinates?.length > 0 ? subOrdinates : [""];
        } else if (isHrDashboard) {
          subOrdinatesList = [""];
        }

        const { todayAttendenceDetails } = await CALL_API(
          `attendance-service/${ClientId}`,
          "post",
          {
            // FIX: was `filteruser?.OfficeSupervisorId` (property on the
            // array itself, always undefined) — should read the first
            // matched user record.
            officesupervisorid: myTeam
              ? filteruser?.[0]?.OfficeSupervisorId === "none"
                ? [""]
                : [filteruser?.[0]?.employeeid]
              : [""],
            country: myTeam
              ? ""
              : selectedManagingOffice
                ? Array.isArray(selectedManagingOffice) && selectedManagingOffice.length > 0
                  ? selectedManagingOffice
                  : [selectedManagingOffice]
                : filteruser?.[0]?.managingoffice,
          }
        );

        let absentList = [];
        let ontimeList = [];
        let lateList = [];
        let leaveList = [];
        todayAttendenceDetails?.forEach((value) => {
          ontimeList = value.onTime;
          lateList = value?.late;
          absentList = value?.absent;
          leaveList = value?.leaveCount;
        });

        // FIX: clone each item instead of spreading the array (which only
        // copies references) — the old code mutated the existing state
        // objects in place before setReportData was even called.
        const dupeReportData = reportData.map((item) => ({ ...item }));

        dupeReportData[0].numbers = size(ontimeList);
        dupeReportData[1].numbers = size(absentList);
        dupeReportData[2].numbers = size(lateList);
        dupeReportData[3].numbers = size(leaveList);
        dupeReportData[0].list = ontimeList;
        dupeReportData[1].list = absentList;
        dupeReportData[2].list = lateList;
        dupeReportData[3].list = leaveList;

        setReportData(dupeReportData);
        setAbsentList(absentList);
        setLateListData(lateList);
        setOnTimeList(ontimeList);
        setLeaveList(leaveList);
      }
    } catch (err) {
      // FIX: previously unhandled — a throw in here (e.g. from unsafe
      // filteruser[0] access) became a silent, repeating unhandled promise
      // rejection and left the loader stuck on `true` forever.
      console.error("Failed to load attendance report:", err);
    } finally {
      // FIX: always resolves the loader, success or failure.
      toggleReportLoader(false);
    }
  };



  const handleFormChange = (value) => {
    setSelectedManagingOffice(value || "");
  };

  useEffect(() => {
    if (selectedManagingOffice !== undefined) {
      getReportData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedManagingOffice]);



  return (
    <>
      <StyledChartContainer>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <div className="name-title">Today's Overall Attendance</div>

          {filteruser?.[0]?.roleid?.includes("2") && !isMyTeam && (
            <Select
              showSearch
              placeholder="Select Country"
              labelInValue
              style={{ width: 200 }}
              value={
                selectedManagingOffice
                  ? { label: selectedManagingOffice, value: selectedManagingOffice }
                  : undefined
              }
              onChange={(option) => {
                form.setFieldsValue({ managingoffice: option });
                handleFormChange(option.label);
              }}
            >
              {uniqBy(
                countryList.map((c) => ({
                  label: c.countryname,
                  value: c.countryname,
                })),
                "value"
              )?.map((option) => (
                <Select.Option key={option.value} value={option.value}>
                  {option.label}
                </Select.Option>
              ))}
            </Select>

          )}

        </div>

        <Spin spinning={displayReportLoader}>
          <Bar {...config} onReady={handlePlotReady} />
        </Spin>
      </StyledChartContainer>
      <DepartmentAttendanceReport
        displayModal={displayDepartmentAttendanceReportModal}
        toggleModal={() => toggleDepartmentAttendanceReportModal(false)}
        reportType={reportType}
        reportColor={reportColor}
        list={reportList}
        name={reportName}
        lateListData={lateListData}
        onTimeList={onTimeList}
        leaveList={leaveList}
        absentList={absentList}
      />
      <AttendanceStaffList
        displayModal={displayAttendanceStaffModal}
        toggleModal={() => toggleDisplayAttendanceStaffModal(false)}
        title={attendanceReportTitle}
        reportType={reportType}
        list={reportList}
        name={reportName}
        isHrDashboard={isHrDashboard}
        userInfo={userInfo}
      />
    </>
  );
}

const mapStateToProps = (state) => ({
  userRoleId: getUserRoleId(state),
  selectedDepartmentId: getSelectedDepartmentId(state),
  ClientId: getClientid(state),
  leaveCategoryList: getLeaveCategoryList(state),
  allDepartmentList: getAllDepartmentList(state),
  userList: getUserList(state),
  isCheckedIn: getIsCheckedIn(state),
  userInfo: getUserInfo(state),
});

export default connect(mapStateToProps, null)(AttendanceBarChart);